module.exports = __webpack_public_path__ + "img/Kindertraume & Spiele.7194ff47.jpg";